import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../components/Header/Header'
import Footer from "../../components/Footer"
import Notification from "../../components/Notification"

const WebsiteLayout = () => {
  const [showScroll, setshowScroll] = useState(true)
  const [showNotif, setShowNotif] = useState({
    show: false,
    message:"Une erreur est survenue",
    variant: "danger"
  })


  return (
    <>
      <div className={
        showScroll ? 
        "min-h-screen selection:bg-primary-green selection:text-black "
        :
        "min-h-screen selection:bg-primary-green selection:text-black max-h-screen overflow-hidden "}>
        <Header />
        <div className="max-w-[1920px]  mx-auto pt-14  md:pt-14  ">
          <Outlet context={{showScroll, setshowScroll, showNotif, setShowNotif}}/>
        </div>
        <Footer/>
      </div>

      <Notification variant={showNotif.variant} text={showNotif.message} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} />
    </>
  )
}

export default WebsiteLayout